import React from "react";
import { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import StatusPledge from "./StatusPledge";
import httpService from "../../../services/httpServices/httpServices";
import helperNumber from "../../../helpers/numbers";
import helperTime from "../../../helpers/time";
import helperSpinner from "../../../helpers/spinner";
import TitleBar from "../../partials/content/TitleBar";
import Pagination from "../../partials/content/Pagination";

function Pledge() {
  const [pledge, setPledge] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [nameCampaignSearchFilter, setNameCampaignSearchFilter] = useState();

  useEffect(() => {
    getAllPledge();
  }, []);

  useEffect(() => {
    getAllPledge();
  }, [currentPage, countItemPerPage, nameCampaignSearchFilter]);

  const getAllPledge = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allPledge = await sendRequestGetAllPledge(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (allPledge === false) {
      return;
    }

    setPledge(allPledge.pledges);
    setCountPage(allPledge.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (nameCampaignSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&name=${nameCampaignSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const generatePledgeTable = () => {
    return (
      <>
        <div className="alert alert-warning ">
          <p className="text-justify">
            <i className="fa fa-info pl-2"></i>
            توجه داشته باشید :{" "}
          </p>
          <ul className="pr-3">
            <li>
              <p className="text-justify">
                بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین شما از
                موجودی حساب شما کسر میشود.
              </p>
            </li>
            <li>
              <p className="text-justify">
                یک سوم مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان
                بیعانه در زمان درج کمپین از موجودی حساب شما کسر میگردد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما بازگردانده
                خواهد شد.
              </p>
            </li>
            <li>
              <p className="text-justify">
                در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما بازگشت
                داده نخواهد شد.
              </p>
            </li>
          </ul>
        </div>

        <div class="container-fluid">
          <div class="row border border-1 rounded py-2">
            <div class="col-12 col-md-4">
              <div>
                <label>جستجو در نام کمپین</label>
              </div>
              <div>
                <input
                  className="form-control"
                  type="text"
                  placeholder="نام کمپین را در اینجا وارد کنید "
                  onKeyUp={(e) => setNameCampaignSearchFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="table-responsive pt-2">
          <table className="table table-hilite tbl-td-white-space table-hover m-0">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره</td>
                <td>مبلغ (تومان)</td>
                <td>نام کمپین</td>
                <td>وضعیت</td>
                <td>تاریخ اخذ</td>
                <td>تاریخ بازگشت</td>
              </tr>
            </thead>
            <tbody>
              {pledge.map((item, key) => {
                return (
                  <tr key={item.id}>
                    <td>{helperNumber.toPersianNum(key + 1)}</td>
                    <td>{helperNumber.toPersianNum(item.id)}</td>
                    <td className="number-finance">
                      {helperNumber.toPersianNum(
                        helperNumber.toFormatFinanceNumber(item.amount)
                      )}
                    </td>
                    <td>{item.campaign}</td>
                    <td>
                      <span
                        className={`badge 
               ${
                 item.status === StatusPledge.statusPledge.BLOCK
                   ? "badge-danger"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GET
                   ? "badge-warning"
                   : ""
               } 
               ${
                 item.status === StatusPledge.statusPledge.GIVE
                   ? "badge-success"
                   : ""
               } 
            `}
                      >
                        {StatusPledge.statusPledgeString()[item.status]}
                      </span>
                    </td>
                    <td>
                      {helperNumber.toPersianNum(
                        helperTime.convertGregorianToJalali(item.created_at)
                      )}
                    </td>
                    <td>
                      {item.returned_at !== null
                        ? helperNumber.toPersianNum(
                            helperTime.convertGregorianToJalali(
                              item.returned_at
                            )
                          )
                        : ""}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const sendRequestGetAllPledge = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let allInvoices;
    try {
      allInvoices = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/pledge?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return allInvoices.data.data;
  };

  const generateDoNotHavePledge = () => {
    return (
      <div class="d-flex flex-column flex-md-row">
        <div class="text-center text-md-right">
          <img class="img-fluid" src="/assets/img/do-not-have-pledge.svg" />
        </div>
        <div class="d-flex flex-column justify-content-center pr-0 pt-3  pr-md-3 pt-md-0">
          <p className="text-justify">
            شما تاکنون کمپین تبلیغاتی نداشته و در نتیجه بیعانه پرداختی ندارید
          </p>
          <p className="text-justify">
            بیعانه مبلغی است که جهت رزور جایگاه های انتخابی کمپین شما از موجودی
            حساب شما کسر میشود.
          </p>
        </div>
      </div>
    );
  };

  return (
    <>
      <Sidebar openItem="all-finance" activeItem="all-pledge" />

      <div className="content-wrapper">
        <TitleBar title="لیست بیعانه   " />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              {pledge.length == 0 && nameCampaignSearchFilter == null
                ? generateDoNotHavePledge()
                : generatePledgeTable()}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Pledge;
